import { Component, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { EmailService } from '../../services/email.service';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrl: './email.component.css'
})
export class EmailComponent {

  
    onCopy = new EventEmitter<ActionButtonEvent>();
    onDelete = new EventEmitter<ActionButtonEvent>();
  
    rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[] = [
      {
        icon: 'content_copy'
        , tooltip: 'Copy',
        eventEmitter: this.onCopy
      },
      {
        icon: 'clear'
        , tooltip: 'Delete',
        eventEmitter: this.onDelete
      }
    ];

  dataSource$: Observable<any[]> = new Observable<any[]>(subscriber => {
    subscriber.next([])
  });

  

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'emailTo',
      name: 'Email'
    },
    {
      columnId: 'cc',
      name: 'CC'
    },
    {
      columnId: 'subject',
      name: 'Subject'
    },
    {
      columnId: 'title',
      name: 'Title'
    },
    {
      columnId: 'includeSignature',
      name: 'Include Signature'
    },
    {
      columnId: 'sendAt',
      name: 'Send At'
    },
    {
      columnId: 'createdAt',
      name: 'Created At'
    },
    {
      columnId: 'status',
      name: 'Status'
    },
    {
      columnId: 'sentAt',
      name: 'Sent At'
    }
  ]

  constructor(
    emailService: EmailService,
    public dialog: MatDialog
  ) {
    this.dataSource$ = emailService.getEmails$();

    this.onCopy.subscribe((event: ActionButtonEvent) => {
      const email = event.eventData; // Cast to any to access properties
      console.log('Edit email:', email);
      this.dialog.open(EmailDialogComponent, {
        width: '1000px',
        data: {
          title: 'Edit Email',
          email: {
            ...email,
            sendAt: new Date(email.sendAt),
            createdAt: new Date(email.createdAt),
            sentAt: email.sentAt ? new Date(email.sentAt) : null
          }
        }
      });
    });

    this.onDelete.subscribe((event: ActionButtonEvent) => {
      const email = event.eventData; // Cast to any to access properties
      console.log('Delete email:', email);
      if (confirm(`Are you sure you want to delete the email to ${email.emailTo}?`)) {
        emailService.deleteEmail(email.id).then(() => {
          console.log('Email deleted successfully');
        }, error => {
          console.error('Error deleting email:', error);
        });
      }
    });
  }

  openMailCopyDialog() {
    this.dialog.open(EmailDialogComponent, {
      width: '1000px',
      data: {
        title: 'New Email',
        email: {
          emailTo: '',
          cc: '',
          subject: '',
          title: '',
          text: '',
          html: '',
          includeSignature: true,
          sendAt: new Date(),
          sendAsHtml: false,
          signatureType: 'frigg'
        }
      }
    })
  }
}
